import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Comment } from "../models/comment";

@Injectable({
  providedIn: "root",
})
export class CommentService {
  private baseUrl = "api/comments";

  constructor(private http: HttpClient) {}

  saveComment(parentId: string, comment: any): Observable<Comment> {
    return this.http.post<Comment>(`${this.baseUrl}/${parentId}/new`, comment);
  }

  getComments(parentId: string) {
    return this.http.get<Comment[]>(`${this.baseUrl}/${parentId}`);
  }
}
